import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-28 pb-12 md:pt-32 md:pb-20 px-4 bg-brand-cream relative overflow-hidden" data-id="element-68">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-40 pointer-events-none" data-id="element-69">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-70"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-brand-sage/10 rounded-full blur-3xl" data-id="element-71"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-72">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-73">
          <div className="lg:w-3/5 text-center lg:text-left" data-id="element-74">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-75">
              How to Claim Your Body Back and Feel Like{' '}
              <span className="text-brand-sage italic" data-id="element-76">YOU</span> Again in Just
              15 Minutes a Day...
            </h1>
            <h2 className="text-xl md:text-2xl text-brand-charcoal/80 mb-8 font-light leading-relaxed" data-id="element-77">
              Without Missing a Single Cuddle, Starving Yourself, or Spending a
              Second in the Gym.
            </h2>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-brand-gold/20 mb-10 inline-block" data-id="element-78">
              <p className="text-lg italic text-brand-charcoal font-medium" data-id="element-79">
                "Finally, a 'Snap-Back' system designed for the Mom who is tired
                of being 'just a mom' and is ready to feel radiant, strong, and
                sexy again."
              </p>
            </div>

            <CTAButton text="YES! I WANT MY IDENTITY BACK – ACCESS NOW" subtext="Secure 256-bit Encrypted Checkout" scrollTo="pricing-section" className="lg:items-start" data-id="element-80" />
          </div>

          <div className="lg:w-2/5 relative" data-id="element-81">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform lg:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/2fSdzgHBn4WfwSMtagXot1/SNAPBACK_Mock_Up.png" alt="The Snap-Back Blueprint Digital Guide on iPad" className="w-full h-auto object-cover" data-id="element-83" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}